var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "a",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPlayButton,
              expression: "showPlayButton"
            },
            {
              name: "tooltip",
              rawName: "v-tooltip.left",
              value: "Preview",
              expression: "'Preview'",
              modifiers: { left: true }
            }
          ],
          staticClass: "recording-cell__btn",
          attrs: { href: "javascript:;" },
          on: { click: _vm.showAudioPlayer }
        },
        [
          _vm.iconButton ? _c("i", { staticClass: "fa fa-play" }) : _vm._e(),
          _vm._v(" "),
          !_vm.iconButton
            ? _c(
                "button",
                {
                  staticClass: "btn btn-primary",
                  attrs: { type: "button", disabled: _vm.disabled }
                },
                [_vm._v("\n      " + _vm._s(_vm.$t("PREVIEW")) + "\n    ")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _vm.audioInfo
        ? _c("AudioPlayer", {
            ref: "audioPlayer",
            attrs: {
              "audio-info": _vm.audioInfo,
              "fixed-player": _vm.fixedPlayer,
              "no-float": _vm.noFloat
            },
            on: { hidePlayer: _vm.hidePlayer }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }